import { type FileId, type UploadedFile } from "@inrev/common";
import { useEffect } from "react";
import { useFetchFileMeta } from "./useFetchFileMeta";

export type FileClassificationSubscriberProps = {
	fileId: FileId;
	onUpdate: (fileId: FileId, file: UploadedFile) => void;
};

export const FileClassificationSubscriber = ({
	fileId,
	onUpdate,
}: FileClassificationSubscriberProps) => {
	const { data } = useFetchFileMeta(fileId, { pollWhileClassificationPending: true });

	useEffect(() => {
		if (!data) return;
		onUpdate(fileId, data);
	}, [data, fileId, onUpdate]);

	return null;
};
